export default __webpack_public_path__ + "0c57d5c00a48f0bd8bd2290662f9acb7.jpg";